<app-breadcrumb [title]="'system license' | translate" [items]="['security' | translate]" [active_item]="'system license' | translate"></app-breadcrumb>
<style>
  .custom-card-erp{
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 800px) {
    .desktop-hidden {
      display: initial;
    }
    .mobile-hidden {
      display: none;
    }
  }
  @media screen and (min-width: 800px) {
    .desktop-hidden {
      display: none;
    }
    .mobile-hidden {
      display: initial;
    }
  }

</style>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">

      <div class="custom-card-erp" *ngIf="'Read' | hasPermission: userPermissions">
        <div style="float:left;">
          <input
                  type="text"
                  style="padding:5px;margin:5px auto;width:30%;"
                  placeholder="{{ 'type to filter the'|translate }} {{ 'name'|translate }} ..."
                  (keyup)="updateFilter($event)"
          />

            <div style="float: right; margin: 5px;">
                <div class="btn-group-vertical me-2" role="group" aria-label="Vertical button group" *ngIf="this.isButtonVisible">
                    <div ngbDropdown placement="top" class="btn-group" role="group">
                        <button type="button" class="btn btn-outline-primary dropdown-toggle" id="dropdownBasic1" ngbDropdownToggle>{{ 'actions'|translate }}</button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button class="dropdown-item" (click)="deleteSelectedSystemLicenseRows()">{{ 'delete selection'|translate }}</button>
                        </div>
                    </div>
                </div>

                <button class="btn btn-outline-primary" (click)="addSystemLicense()" *ngIf="'Create' | hasPermission: userPermissions">{{ 'add'|translate }}</button>
            </div>

        </div>


          <ngx-datatable
                  style="width: 100%"
                  class="material striped"
                  selectionType="checkbox"
                  [rows]="rows"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [limit]="100"
                  rowHeight="auto"
                  columnMode="force"
                  [scrollbarH]="true"
                  [loadingIndicator]="loadingIndicator"
                  [reorderable]="reorderable"
                  [selected]="selected"
                  (activate)="onActivate($event)"
                  (select)="onSelect($event)"
                  [selectAllRowsOnPage]="false"
                  [displayCheck]="displayCheck"
          >
            <ngx-datatable-column
                    [width]="55"
                    [sortable]="false"
                    [canAutoResize]="false"
                    [draggable]="false"
                    [resizeable]="false"
                    [headerCheckboxable]="true"
                    [checkboxable]="true"
            >

            </ngx-datatable-column>

            <ngx-datatable-column name="licenseKey">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span class="f-w-700 sp-policy-erp">{{ 'license Key'|translate }}</span>
              </ng-template>
            </ngx-datatable-column>

              <ngx-datatable-column name="customer">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{'customer'|translate}}</span>
                  </ng-template>
                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      {{row.customer ? row.customer.name : "" }}
                  </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="startAt">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{ 'start date'|translate }}</span>
                  </ng-template>
                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      {{row.startAt | date}}
                  </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="endAt">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{ 'end date'|translate }}</span>
                  </ng-template>
                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      {{row.endAt | date}}
                  </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="status">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{ 'status'|translate }}</span>
                  </ng-template>

                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <ng-container *ngIf="row.status == 'generate';">
                          <span class="badge rounded-pill badge-light-primary" style="font-size: 13px">{{ 'generate' | translate }}</span>
                      </ng-container>
					  <ng-container *ngIf="row.status == 'activated';">
                          <span class="badge rounded-pill badge-light-success" style="font-size: 13px">{{ 'activated' | translate }}</span>
                      </ng-container>
                      <ng-template *ngIf="row.status == 'expired';">
                          <span class="badge rounded-pill badge-light-danger" style="font-size: 13px">{{ 'expired' | translate }}</span>
                      </ng-template>
                  </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="isEnable">
                  <ng-template let-column="column" ngx-datatable-header-template>
                      <span class="f-w-700 sp-policy-erp">{{ 'status'|translate }}</span>
                  </ng-template>

                  <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                      <ng-container *ngIf="row.isEnable == 1; else otherFormat">
                          <span class="badge rounded-pill badge-light-success" style="font-size: 13px">{{ 'enabled' | translate }}</span>
                      </ng-container>
                      <ng-template #otherFormat>
                          <span class="badge rounded-pill badge-light-danger" style="font-size: 13px">{{ 'disabled' | translate }}</span>
                      </ng-template>
                  </ng-template>
              </ngx-datatable-column>
            
            <ngx-datatable-column name="actions">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span class="f-w-700 sp-policy-erp">{{ 'actions'|translate }}</span>
              </ng-template>
              <ng-template  let-row="row" let-value="value" ngx-datatable-cell-template>
                  <a (click)="deleteSystemLicense(row.id)" placement="top" ngbTooltip="{{'delete'| translate}}" *ngIf="row.status == 'generate' && 'Delete' | hasPermission: userPermissions"><i class="icon-trash text-danger ms-2" style="cursor: pointer"></i></a>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
      </div>
    </div>
    </div>
  </div>
